<template>
    <vue-autocomplete
    class="w-100"
    :data="items"
    placeholder="Digite Para Pesquisar Exames..."
    v-model="query"
    :serializer="item => item.exame + ' - ' + item.salaExame"
    @hit="selecionarExame($event)"
    @input="buscarExames"
    showOnFocus
    :disabled="disabled"
    :maxMatches=parseInt(5)>
  <template slot="suggestion" slot-scope="{ htmlText }">
    <div class="d-flex">
        <b-spinner v-show="carregando" variant="primary" class="mx-auto"></b-spinner>
        <span class="ml-4" v-html="htmlText" v-show="!carregando"></span>
    </div>
  </template>
</vue-autocomplete>
</template>
<script>
import ExameService from "../../service/ExameService.js";

export default {
	props: [ "disabled", "value" ],
	data() {
		return {
			query: this.value,
			items: [],
			carregando: false,
		};
	},
	created() {
		this.buscarExames();
	},
	watch: {
		value(newValue, oldValue) {
			if (newValue == "") {
				this.query = newValue;
			}
		},
	},
	methods: {
		buscarExames() {
			this.carregando = true;
			ExameService.consultar()
				.then((res) => {
					this.items = res.data;
				}).finally(() => {
					this.carregando = false;
				});
		},
		selecionarExame(item) {
			this.$emit("exameSelecionado", item);
		},
		limpar() {
			this.query = "";
			this.items = [];
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/Agendamento/AutoCompleteExame.vue